module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/icons-bea989e82b07e9687c26fc58a4805021.woff";